//@formatter:off
/**
 * @ngdoc filter
 * @name byte
 * @module portaro.filters
 * @kind function
 *
 * @deprecated use updated svelte pipe operator {@link byteFormatter}
 *
 * @param {number} bytes Size in bytes
 * @param {number=} precision Precision. Count of decimal positions. Default `0`
 *
 * @return {string} Human readable formatted value
 *
 * @description
 * Filter transforms byte size into human readable string with unit name. 1024 -> 1kb.
 *
 * @example
 * <example module="bytesFilterExample" name="bytesFilterExample" frame-no-resize="true">
    <file name="index.html">
        <main ng-init="byteValue = 0; precision = 2;">
            <div>
                <label for="input">Raw value: </label>
                <input id="input" type="text" ng-model="byteValue">
            </div>
            <div>
                <label for="precision">Precision: </label>
                <input id="precision" type="number" ng-model="precision">
            </div>
            <div>
                Human readable: {{byteValue | bytes : precision}}
            </div>
        </main>
    </file>
    <file name="script.js">
        angular.module('bytesFilterExample', ['portaro.filters']);
    </file>
 * </example>
 */
 //@formatter:on
export default function bytesFilter() {
    return (bytes, precision = 0) => {
        const fBytes = parseFloat(bytes);
        if (isNaN(fBytes) || !isFinite(bytes)) return '-';
        if (fBytes === 0) return '0B';
        const units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB'], number = Math.floor(Math.log(bytes) / Math.log(1024));
        return (bytes / Math.pow(1024, Math.floor(number))).toFixed(precision) + units[number];
    };
}

bytesFilter.filterName = 'bytes';